import * as Yup from "yup";

const sizeSchema = Yup.object({
  length: Yup.string().required("Length is required."),
  width: Yup.string().required("Width is required."),
  height: Yup.string().required("Height is required."),
});

const validationSchema = Yup.object({
  name: Yup.string().required("Product Name is required."),
  code: Yup.string().required("Product Code is required."),
  quantity: Yup.string().required("Quantity is required."),
  category: Yup.object().required("Category is required."),
  itemFinish: Yup.string().required("Item Finish is required."),
  locationName: Yup.string().required("Location Name is required."),
  centimeter: sizeSchema,
  inch: sizeSchema,
  images: Yup.array()
    .required("Product Image is required.")
    .min(1, "At least 1 product image is required."),
});

export { validationSchema };
